import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty as _isEmpty } from 'lodash';

import { Box, AlertTriangleFillIcon } from '@metarouter-private/mr-mui';

import WithTooltip from 'app/components/WithTooltip';

const tooltipProps = {
  title: 'Filter(s) applied',
  dataTestId: 'FiltersTooltip',
};

const boxProps = {
  display: 'flex',
  alignItems: 'center',
};

export default function FiltersIndicator({ filters }) {
  if (_isEmpty(filters)) {
    return null;
  }

  return (
    <WithTooltip show {...tooltipProps} Container={Box} ContainerProps={boxProps}>
      <AlertTriangleFillIcon fontSize="small" color="warning" />
    </WithTooltip>
  );
}

FiltersIndicator.propTypes = {
  filters: PropTypes.array,
};
